import { useRef, useState } from 'react';
import styles from './mapacomarques.module.scss';
import type { ComarcaData, MapaComarquesProps } from './MapaComarques.types';
import Icona from 'components/corporatiu/ui/Icona';
import Dropdown from 'components/corporatiu/Dropdown/Dropdown';

// Dades de les comarques: codi -> { slug, nom, path SVG }
// Paths extrets del fitxer jvectormap jquery-jvectormap-cat.js (viewBox 0 0 550 550)
const COMARQUES: ComarcaData[] = [
    {
        codi: '01',
        slug: 'alt-camp',
        nom: 'Alt Camp',
        path: 'M230.2, 324.2, 240.2, 334.1, 222.1, 352.2, 222.1, 369.8, 201.8, 369.8, 197.1, 375.1, 180.0, 375.1, 162.6, 357.8, 174.5, 357.8, 208.0, 324.2, 230.2, 324.2Z'
    },
    {
        codi: '02',
        slug: 'alt-emporda',
        nom: 'Alt Empordà',
        path: 'M507.6, 131.2, 501.7, 125.3, 493.8, 132.4, 493.8, 151.2, 503.6, 161.1, 456.5, 161.1, 456.5, 142.6, 436.0, 142.6, 436.0, 132.2, 419.4, 132.2, 402.6, 115.4, 396.9, 115.4, 396.9, 109.5, 415.3, 109.5, 415.3, 100.7, 421.8, 94.2, 435.4, 94.2, 447.1, 82.3, 475.8, 82.3, 481.3, 87.8, 498.2, 87.8, 498.2, 107.9, 520.1, 107.9, 525.1, 113.0, 516.9, 121.2, 516.9, 131.2, 507.6, 131.2Z'
    },
    {
        codi: '03',
        slug: 'alt-penedes',
        nom: 'Alt Penedès',
        path: 'M256.3, 355.7, 248.5, 355.7, 248.5, 342.5, 230.2, 324.2, 240.8, 324.3, 255.7, 309.4, 268.0, 309.4, 279.0, 320.5, 288.9, 310.6, 300.7, 322.4, 300.7, 341.4, 295.0, 347.1, 281.6, 347.1, 262.1, 366.7, 256.3, 366.7, 256.3, 355.7Z'
    },
    {
        codi: '04',
        slug: 'alt-urgell',
        nom: 'Alt Urgell',
        path: 'M213.3, 105.1, 230.7, 105.1, 235.6, 100.1, 248.9, 113.6, 249.0, 155.0, 232.5, 155.0, 219.1, 168.4, 203.3, 168.4, 203.3, 202.9, 195.8, 210.5, 163.5, 178.2, 163.5, 141.9, 183.3, 121.9, 183.4, 103.4, 203.9, 83.0, 213.3, 83.0, 213.3, 105.1Z'
    },
    {
        codi: '05',
        slug: 'alta-ribagorca',
        nom: 'Alta Ribagorça',
        path: 'M95.9, 70.5, 95.9, 133.3, 126.0, 133.3, 125.9, 122.0, 112.5, 108.2, 136.5, 84.2, 136.5, 70.5, 95.9, 70.5Z'
    },
    {
        codi: '06',
        slug: 'anoia',
        nom: 'Anoia',
        path: 'M240.8, 324.3, 255.7, 309.4, 268.0, 309.4, 279.0, 320.5, 288.9, 310.6, 288.9, 287.7, 279.5, 278.3, 248.8, 278.3, 248.8, 246.2, 219.1, 246.2, 219.1, 313.1, 230.3, 324.2, 240.8, 324.3Z'
    },
    {
        codi: '07',
        slug: 'bages',
        nom: 'Bages',
        path: 'M300.767,245.912L312.768,234.089L305.684,227.005L310.96,221.758L298.369,209.883L293.881,209.883L293.881,209.885L256.983,209.885L248.275,218.592L248.275,277.673L278.925,277.673L288.269,287.021L304.701,270.587L312.849,270.607L312.834,257.997z'
    },
    {
        codi: '08',
        slug: 'baix-camp',
        nom: 'Baix Camp',
        path: 'M153.3, 357.8, 138.8, 372.4, 138.7, 395.8, 121.6, 412.9, 121.6, 439.4, 132.3, 439.4, 164.1, 407.6, 180.0, 407.6, 180.0, 375.1, 162.6, 357.8, 153.3, 357.8Z'
    },
    {
        codi: '09',
        slug: 'baix-ebre',
        nom: 'Baix Ebre',
        path: 'M48.8, 456.0, 48.8, 446.7, 62.8, 432.6, 72.2, 432.6, 82.5, 422.2, 82.5, 422.3, 82.5, 439.4, 132.3, 439.4, 108.8, 462.9, 108.8, 476.7, 121.7, 476.7, 132.5, 487.6, 128.2, 492.3, 87.0, 492.3, 86.9, 485.4, 39.2, 485.4, 29.4, 475.6, 48.8, 456.0Z'
    },
    {
        codi: '10',
        slug: 'baix-emporda',
        nom: 'Baix Empordà',
        path: 'M512.0, 169.4, 507.8, 173.5, 507.8, 183.1, 513.6, 188.9, 513.6, 203.7, 476.2, 241.0, 472.0, 237.0, 472.0, 217.7, 459.2, 204.9, 468.3, 195.9, 468.3, 161.1, 503.7, 161.1, 512.0, 169.4Z'
    },
    {
        codi: '11',
        slug: 'baix-llobregat',
        nom: 'Baix Llobregat',
        path: 'M295.0, 347.1, 300.7, 341.4, 300.7, 322.4, 288.9, 310.6, 288.9, 287.7, 292.2, 284.4, 309.0, 301.1, 309.0, 315.8, 329.6, 315.8, 329.6, 334.4, 342.2, 347.0, 330.1, 359.0, 308.5, 359.0, 308.5, 352.8, 300.7, 352.8, 295.0, 347.1Z'
    },
    {
        codi: '12',
        slug: 'baix-penedes',
        nom: 'Baix Penedès',
        path: 'M234.4, 382.2, 222.1, 369.7, 222.1, 352.2, 240.1, 334.2, 248.5, 342.5, 248.5, 355.7, 256.3, 355.7, 256.3, 377.8, 238.9, 377.8, 234.4, 382.2Z'
    },
    {
        codi: '13',
        slug: 'barcelones',
        nom: 'Barcelonès',
        path: 'M364.4, 314.0, 355.3, 304.9, 338.9, 321.2, 329.6, 321.2, 329.6, 334.3, 342.2, 347.0, 347.9, 341.4, 347.9, 330.6, 364.4, 314.0Z'
    },
    {
        codi: '14',
        slug: 'bergueda',
        nom: 'Berguedà',
        path: 'M288.9,209.883L301.812,195.708L302.041,176.612L316.429,164.642L316.429,127.909L276.897,127.86L264.808,140.033L248.447,140.024L248.429,154.674L256.983,163.348L256.983,209.883z'
    },
    {
        codi: '15',
        slug: 'cerdanya',
        nom: 'Cerdanya',
        path: 'M235.6, 100.1,248.1, 87.8,282.9, 87.8,289.5, 94.4,295.4, 90.3,299.8, 95.5,294.8, 99.7,309.4, 114.3,309.4, 128.1,277.5, 128.1,265.4, 140.3,249.0, 140.3,249.0, 113.5,235.6, 100.1Z'
    },
    {
        codi: '16',
        slug: 'conca-de-barbera',
        nom: 'Conca de Barberà',
        path: 'M230.3, 324.2, 219.1, 313.1, 219.1, 297.8, 181.8, 297.8, 181.8, 307.8, 142.5, 346.9, 153.3, 357.8, 174.5, 357.8, 208.0, 324.2, 230.3, 324.2Z'
    },
    {
        codi: '17',
        slug: 'garraf',
        nom: 'Garraf',
        path: 'M256.3, 377.8, 256.3, 366.7, 262.1, 366.7, 281.6, 347.1, 295.0, 347.1, 300.7, 352.8, 308.5, 352.8, 308.5, 359.1, 308.7, 359.1, 301.0, 366.7, 280.2, 366.7, 269.2, 377.8, 256.3, 377.8Z'
    },
    {
        codi: '18',
        slug: 'garrigues',
        nom: 'Garrigues',
        path: 'M147.3, 303.6, 166.8, 322.8, 142.5, 346.9, 114.4, 347.0, 104.6, 356.8, 84.2, 356.8, 84.2, 332.1, 112.5, 303.5, 147.3, 303.6Z'
    },
    {
        codi: '19',
        slug: 'garrotxa',
        nom: 'Garrotxa',
        path: 'M419.4, 132.2, 436.0, 132.2, 436.0, 148.0, 419.3, 148.0, 419.3, 171.0, 410.0, 180.0, 391.6, 180.1, 367.4, 155.9, 367.4, 129.7, 392.8, 129.7, 392.7, 115.4, 402.6, 115.4, 419.4, 132.2Z'
    },
    {
        codi: '20',
        slug: 'girones',
        nom: 'Gironès',
        path: 'M472.0, 217.7, 472.0, 236.8, 454.7, 236.8, 454.7, 224.7, 410.0, 180.1, 419.3, 171.0, 434.3, 171.0, 444.6, 181.0, 456.5, 168.9, 456.5, 161.1, 468.3, 161.1, 468.3, 195.9, 459.2, 204.9, 472.0, 217.7Z'
    },
    {
        codi: '21',
        slug: 'maresme',
        nom: 'Maresme',
        path: 'M415.864,283.338h-13.576l-22.072,22.094h-8.671l-7.991,7.856l-9.132-9.118l32.222-31.966h15.555l27.798-27.754l15.69,16.096l-7.805,7.827h-6.861L415.864,283.338z'
    },
    {
        codi: '22',
        slug: 'montsia',
        nom: 'Montsià',
        path: 'M29.4, 475.6, 39.2, 485.4, 86.9, 485.4, 87.0, 492.3, 128.2, 492.3, 135.7, 484.2, 140.5, 489.0, 101.7, 527.8, 92.5, 527.8, 92.5, 520.0, 99.4, 520.0, 110.2, 509.1, 95.4, 509.1, 72.5, 532.3, 55.5, 516.6, 45.5, 516.6, 17.0, 487.9, 29.4, 475.6Z'
    },
    {
        codi: '23',
        slug: 'noguera',
        nom: 'Noguera',
        path: 'M124.7, 261.6, 112.5, 273.7, 103.0, 273.7, 72.3, 243.0, 72.3, 218.5, 96.0, 194.8, 146.8, 194.9, 163.5, 178.2, 195.8, 210.4, 195.8, 220.9, 175.6, 241.1, 157.3, 241.1, 136.7, 261.6, 124.7, 261.6Z'
    },
    {
        codi: '24',
        slug: 'osona',
        nom: 'Osona',
        path: 'M390.646,179.675L366.545,155.604L359.806,162.36L316.407,162.376L316.409,164.657L317.1,164.083L325.05,164.083L335.5,176.454L335.615,214.016L332.979,214.016L332.839,214.016L332.839,224.64L341.104,224.64L341.104,224.642L341.104,236.448L351.571,246.913L362.033,236.448L383.311,236.448L383.311,197.285L390.69,190.065z'
    },
    {
        codi: '25',
        slug: 'pallars-jussa',
        nom: 'Pallars Jussà',
        path: 'M96.0, 194.9, 146.8, 194.9, 163.5, 178.2, 163.5, 141.9, 144.7, 141.9, 144.7, 84.1, 136.5, 84.2, 112.5, 108.2, 125.9, 122.0, 125.9, 133.2, 96.0, 133.2, 96.0, 194.9Z'
    },
    {
        codi: '26',
        slug: 'pallars-sobira',
        nom: 'Pallars Sobirà',
        path: 'M196.8, 44.7, 213.3, 61.2, 213.3, 83.0, 203.8, 83.0, 183.3, 103.5, 183.3, 122.0, 163.6, 141.9, 144.7, 141.9, 144.7, 84.1, 136.5, 84.1, 136.5, 53.5, 144.7, 45.3, 144.7, 27.7, 153.2, 27.7, 170.1, 44.7, 196.8, 44.7Z'
    },
    {
        codi: '27',
        slug: 'pla-d-urgell',
        nom: "Pla d'Urgell",
        path: 'M112.5, 303.5, 112.4, 273.7, 124.7, 261.6, 136.7, 261.6, 154.2, 278.6, 147.4, 285.3, 147.4, 303.5, 112.5, 303.5Z'
    },
    {
        codi: '28',
        slug: 'pla-de-l-estany',
        nom: "Pla de l'Estany",
        path: 'M419.3, 170.9, 419.3, 148.0, 436.0, 148.0, 436.0, 142.6, 456.5, 142.6, 456.5, 169.0, 444.6, 181.1, 434.4, 171.0, 419.3, 170.9Z'
    },
    {
        codi: '29',
        slug: 'priorat',
        nom: 'Priorat',
        path: 'M96.3, 387.6, 104.6, 379.3, 104.6, 356.8, 114.5, 347.0, 142.5, 346.9, 153.3, 357.8, 138.8, 372.4, 138.7, 395.8, 121.6, 412.9, 96.3, 387.6Z'
    },
    {
        codi: '30',
        slug: 'ribera-d-ebre',
        nom: "Ribera d'Ebre",
        path: 'M73.2, 412.9, 82.5, 422.3, 82.5, 439.4, 121.6, 439.4, 121.6, 412.9, 96.3, 387.6, 104.6, 379.3, 104.6, 356.8, 84.2, 356.8, 75.9, 365.1, 49.9, 365.1, 49.9, 378.5, 58.2, 378.5, 82.9, 403.2, 73.2, 412.9Z'
    },
    {
        codi: '31',
        slug: 'ripolles',
        nom: 'Ripollès',
        path: 'M360.7, 162.7, 367.4, 155.9, 367.4, 129.7, 392.8, 129.7, 392.8, 115.4, 382.8, 115.4, 364.2, 97.0, 338.2, 97.0, 320.9, 114.3, 309.4, 114.3, 309.4, 128.1, 317.1, 128.1, 317.1, 162.7, 360.7, 162.7Z'
    },
    {
        codi: '32',
        slug: 'segarra',
        nom: 'Segarra',
        path: 'M219.1, 246.2, 229.1, 246.2, 229.1, 220.9, 195.7, 220.9, 175.6, 241.1, 175.6, 267.0, 181.8, 267.0, 181.8, 297.8, 219.1, 297.8, 219.1, 246.2Z'
    },
    {
        codi: '33',
        slug: 'segria',
        nom: 'Segrià',
        path: 'M103.0, 273.7, 72.3, 243.0, 36.3, 279.0, 36.3, 297.0, 54.3, 297.0, 54.3, 315.9, 38.1, 332.2, 38.1, 353.4, 49.8, 365.1, 75.9, 365.1, 84.2, 356.8, 84.2, 332.1, 112.5, 303.6, 112.5, 273.7, 103.0, 273.7Z'
    },
    {
        codi: '34',
        slug: 'selva',
        nom: 'Selva',
        path: 'M446.8, 261.2, 455.1, 252.9, 464.3, 252.9, 476.2, 241.0, 472.0, 236.8, 454.7, 236.8, 454.7, 224.8, 409.9, 180.1, 391.6, 180.0, 391.6, 190.6, 384.2, 197.7, 384.2, 237.0, 398.0, 237.0, 418.6, 257.5, 431.0, 245.0, 446.8, 261.2Z'
    },
    {
        codi: '35',
        slug: 'solsones',
        nom: 'Solsonès',
        path: 'M248.9, 155.0, 232.5, 155.0, 219.2, 168.4, 203.3, 168.3, 203.3, 202.9, 195.7, 210.5, 195.7, 220.9, 229.1, 220.9, 229.1, 246.2, 248.8, 246.2, 248.8, 219.1, 257.5, 210.3, 257.5, 163.7, 248.9, 155.0Z'
    },
    {
        codi: '36',
        slug: 'tarragones',
        nom: 'Tarragonès',
        path: 'M180.0, 407.6, 180.0, 375.1, 197.1, 375.1, 201.8, 369.8, 222.1, 369.8, 234.4, 382.2, 222.2, 394.5, 201.7, 394.5, 184.3, 411.9, 180.0, 407.6Z'
    },
    {
        codi: '37',
        slug: 'terra-alta',
        nom: 'Terra Alta',
        path: 'M21.2, 416.9, 21.2, 400.7, 31.3, 400.7, 38.1, 393.9, 38.1, 378.5, 58.2, 378.5, 82.9, 403.2, 73.2, 412.9, 82.5, 422.2, 72.2, 432.6, 62.8, 432.6, 48.8, 446.7, 48.8, 456.0, 37.6, 467.2, 29.5, 459.1, 29.5, 425.2, 21.2, 416.9Z'
    },
    {
        codi: '38',
        slug: 'urgell',
        nom: 'Urgell',
        path: 'M147.4, 285.4, 147.4, 303.5, 166.7, 322.8, 181.8, 307.8, 181.8, 267.0, 175.6, 267.0, 175.6, 241.1, 157.3, 241.1, 136.7, 261.6, 154.1, 278.6, 147.4, 285.4Z'
    },
    {
        codi: '39',
        slug: 'vall-d-aran',
        nom: "Vall d'Aran",
        path: 'M144.7, 27.7, 119.8, 27.7, 108.5, 16.5, 83.8, 16.5, 83.8, 58.4, 95.9, 70.5, 136.5, 70.5, 136.5, 53.6, 144.7, 45.3, 144.7, 27.7Z'
    },
    {
        codi: '40',
        slug: 'valles-occidental',
        nom: 'Vallès Occidental',
        path: 'M304.69,270.591l-13.105,13.117l16.667,16.684l0.034,14.689l20.546-0.003v5.368l9.319-0.033l16.273-16.232l-0.043-15.357l-17.114-17.109v-13.73l-24.436,0.012l0.018,12.617L304.69,270.591z'
    },
    {
        codi: '41',
        slug: 'valles-oriental',
        nom: 'Vallès Oriental',
        path: 'M351.583,257.983l-0.009-11.083l10.47-10.458l35.005,0.014l20.498,20.436L402.2,272.211l-15.573-0.022l-32.195,31.977l-0.035-15.334l-17.121-17.113l-0.012-13.74L351.583,257.983z'
    },
    {
        codi: '42',
        slug: 'moianes',
        nom: 'Moianès',
        path: 'M351.587,257.983l-38.765,0.003l-12.056,-12.074l12.001,-11.825l-7.082,-7.084l13.06,-12.985l14.094,0l0,10.626l8.264,0l0,11.804l10.466,10.464z'
    },
    {
        codi: '43',
        slug: 'llucanes',
        nom: 'Lluçanès',
        path: 'M318.745,214.016L310.979,221.776L298.369,209.883L288.9,209.885L301.812,195.708L302.041,176.612L317.1,164.083L325.05,164.083L335.5,176.454L335.615,214.016z'
    }
];

// Llista de comarques per al selector (ordenades alfabèticament, sense "fora de Catalunya")
const COMARQUES_SELECT = [...COMARQUES].sort((a, b) => a.nom.localeCompare(b.nom, 'ca'));
const COMARQUES_DROPDOWN_ITEMS = [
    {
        id: 'fora-catalunya',
        titol: 'A fora de Catalunya',
        slug: 'fora-catalunya'
    },
    ...COMARQUES_SELECT.map((comarca) => ({
        id: comarca.codi,
        titol: comarca.nom,
        slug: comarca.slug
    }))
];

export default function MapaComarques({ anyEdicio, idEdicio }: MapaComarquesProps) {
    const [hoveredSlug, setHoveredSlug] = useState<string | null>(null);
    const [tooltipPosition, setTooltipPosition] = useState<{ x: number; y: number } | null>(null);
    const mapaWrapperRef = useRef<HTMLDivElement | null>(null);
    const mapaLabelId = 'mapa-comarques-label';

    if (!anyEdicio || !idEdicio) return null;

    const buildUrl = (slug: string) => `/tv3/marato/activitats-populars/${anyEdicio}/${slug}/${idEdicio}/`;

    const updateDropdown = (item: { slug?: string }) => {
        if (item.slug) {
            window.location.assign(buildUrl(item.slug));
        }
    };

    const hoveredNom = hoveredSlug ? (COMARQUES.find((c) => c.slug === hoveredSlug)?.nom ?? null) : null;

    const updateTooltipPosition = (clientX: number, clientY: number) => {
        const wrapper = mapaWrapperRef.current;

        if (!wrapper) return;

        const rect = wrapper.getBoundingClientRect();
        const offsetX = 14;
        const offsetY = 14;

        setTooltipPosition({
            x: clientX - rect.left + offsetX,
            y: clientY - rect.top + offsetY
        });
    };

    const updateTooltipPositionFromElement = (element: SVGPathElement) => {
        const wrapper = mapaWrapperRef.current;

        if (!wrapper) return;

        const wrapperRect = wrapper.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        setTooltipPosition({
            x: elementRect.left - wrapperRect.left + elementRect.width / 2 + 14,
            y: elementRect.top - wrapperRect.top + elementRect.height / 2 + 14
        });
    };

    const handleComarcaHover = (slug: string, clientX: number, clientY: number) => {
        setHoveredSlug(slug);
        updateTooltipPosition(clientX, clientY);
    };

    return (
        <section className={styles.mapaComarques} aria-label='Mapa de comarques de Catalunya'>
            <span id={mapaLabelId} className={styles.srOnly}>
                Mapa de comarques de Catalunya. Clica una comarca per veure les activitats populars de la Marató.
            </span>
            {COMARQUES.map((c) => (
                <span key={c.codi} id={`comarca-label-${c.codi}`} className={styles.srOnly}>
                    {c.nom}
                </span>
            ))}

            {/* Selector desplegable */}
            <div className={styles.selector}>
                <Dropdown
                    estil='selectorResultats'
                    items={COMARQUES_DROPDOWN_ITEMS}
                    updateDropdown={updateDropdown}
                    textSelector='Tria una comarca'
                />
            </div>

            {/* Mapa SVG interactiu */}
            <div className={styles.mapaWrapper} ref={mapaWrapperRef}>
                <svg
                    className={styles.mapa}
                    viewBox='0 0 550 550'
                    xmlns='http://www.w3.org/2000/svg'
                    role='group'
                    aria-labelledby={mapaLabelId}
                >
                    {COMARQUES.map((c) => (
                        <a key={c.codi} href={buildUrl(c.slug)} aria-labelledby={`comarca-label-${c.codi}`}>
                            <path
                                d={c.path}
                                className={`${styles.comarca} ${hoveredSlug === c.slug ? styles.comarcaHover : ''}`}
                                onMouseEnter={(e) => handleComarcaHover(c.slug, e.clientX, e.clientY)}
                                onMouseMove={(e) => updateTooltipPosition(e.clientX, e.clientY)}
                                onMouseLeave={() => {
                                    setHoveredSlug(null);
                                    setTooltipPosition(null);
                                }}
                                onFocus={(e) => {
                                    setHoveredSlug(c.slug);
                                    updateTooltipPositionFromElement(e.currentTarget);
                                }}
                                onBlur={() => setHoveredSlug(null)}
                            />
                        </a>
                    ))}
                </svg>

                {/* Tooltip del nom de la comarca */}
                {hoveredNom && (
                    <div
                        className={styles.tooltip}
                        aria-hidden='true'
                        style={
                            tooltipPosition
                                ? {
                                      left: `${tooltipPosition.x}px`,
                                      top: `${tooltipPosition.y}px`
                                  }
                                : undefined
                        }
                    >
                        {hoveredNom}
                    </div>
                )}

                {/* Botó "A fora de Catalunya" */}
                <a className={styles.botoForaCat} href={buildUrl('fora-catalunya')} aria-label='A fora de Catalunya'>
                    <span className='sr-only'>A fora de Catalunya</span>
                </a>
            </div>
        </section>
    );
}
